export default "__VITE_ASSET__BYLIfu9u__"